// export default PriceDisplay;
import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCurrencyRates, fetchLocation } from './features/currencylistSlice';

const PriceDisplay = ({ priceUSD }) => {
    const dispatch = useDispatch();
    const { location, currencyRates, loading } = useSelector(state => state.api);

    useEffect(() => {
        if (!location.currency) {
            dispatch(fetchLocation());
        }
        // if (!currencyRates) {
        //     dispatch(fetchCurrencyRates());
        // }
    }, [dispatch, location.currency, currencyRates]);

    if (loading || !location.currency) {
        return <>₹{Number(priceUSD).toFixed(0)}</>;
    }

    const rate = currencyRates?.[location.currency] || 1;
    const convertedPrice = priceUSD * rate;

    return (
        <>{location.currency} {convertedPrice.toFixed(0)}</>
    );
};

export default PriceDisplay;
